import {COOKIE_CONSENT} from '../../serve/consts';
import {get, set} from '../../serve/localStorage';
import {CookieConsent} from './types';

export type {CookiesDto} from './types';
export type {CookieConsent};

import {isCookieConsentExpired} from './lib/isCookieConsentExpired';
import {transformToDto} from './lib/transformToDto';

export function getCookieConsent() {
  if (typeof window === 'undefined') {
    return null;
  }

  const cookieConsent = get<CookieConsent>(COOKIE_CONSENT);
  if (isCookieConsentExpired(cookieConsent)) {
    return null;
  }

  return cookieConsent;
}

export function setCookieConsent(value: CookieConsent): void {
  set<CookieConsent>(COOKIE_CONSENT, value);
}

export function getCookieConsentDto() {
  return transformToDto(getCookieConsent());
}
